const DescriptionPro = () => {
  return (
    <div className="bg-white rounded-2xl mx-auto">
      <h2 className="text-2xl font-bold text-baseBlue mb-4">
        Pro Armwrestling Course
      </h2>
      <p className="text-baseBlue leading-relaxed mb-4">
        The <strong>Pro Armwrestling Course</strong> gives you everything you
        need to become a champion. From the early beginnings of arm wrestling to
        advanced knowledge, this guide covers it all.
      </p>
      <p className="text-baseBlue leading-relaxed mb-4">
        You'll find expert training tips and schedules, the purpose of each
        exercise, and how to use them effectively on the table. Learn from{" "}
        <strong>Mamuka Bilanishvili</strong> and his top athletes,{" "}
        <strong>Bacho</strong> and <strong>Nugo</strong>.
      </p>
      <p className="text-baseBlue leading-relaxed mb-4">
        After completing this course, you'll gain professional-level knowledge
        about arm wrestling, including the secrets that make the{" "}
        <strong>AWC Garejelebi Club</strong> one of the most successful in the
        world, with nearly 20 European and World Champions and many East vs.
        West stars.
      </p>
      <div className="bg-gray-100 border-l-4 border-baseBlue p-4 text-baseBlue rounded-lg">
        <p className="leading-relaxed font-semibold">
          🎯 The course is in Georgian with English subtitles, making it easy to
          follow along. Plus, it includes a live private consultation with the
          coach! We're here to support you every step of the way.
        </p>
      </div>
    </div>
  );
};

export default DescriptionPro;
